export default __webpack_public_path__ + "static/media/flower-alt.ae5f9602.svg";